import { gql } from '@apollo/client';

export type Patient = {
  contact: {
    address: string;
    city: string;
    state: string;
    country: string;
    zip: string;
    phone1: string;
    phone2: string;
  };
  secondaryContact: {
    name: string;
    phone: string;
    relationship: string;
    email: string;
  };
  patientId: string;
  dob: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  email: string;
  weight: number;
  height: number;
  isMetric: boolean;
};

const PatientFragment = gql`
  fragment PatientFragment on Patient {
    contact {
      address
      city
      state
      country
      zip
      phone1
      phone2
    }
    secondaryContact {
      name
      phone
      relationship
      email
    }
    patientId
    dob
    firstName
    middleName
    lastName
    gender
    email
    weight
    height
    isMetric
  }
`;

export default PatientFragment;
